const chatStringsEN = {
  title: 'Varo chat',
  statusBanner: {
    checkOurFAQ:
      'In the meantime, check our FAQ for instant answers or give us a call.',
    tryAgainLater: 'Try again later or email us in the meantime.',
    wereWorkingOnIt: `We're working on it, so try back later. In the meantime, check our FAQ for instant answers or give us a call.`,
    helpingOthers:
      'Our representatives are currently helping others. In the meantime, check our FAQ or try back later.',
    offlineTitle: 'All our chat representatives have gone home for the day.',
    downTitle: 'Chat is currently down',
    busyTitle: 'Chat is busy right now',
  },

  sendMessageError: 'We’ve encountered an error, please try again later.',

  inputBox: {
    maxCharactersError: 'Characters limit reached',
    emptyMessageError: 'Message cannot be empty',
    placeholder: 'Type to chat',
    sendMessageError: 'Your message wasn’t sent. Try again.',
    responding: 'Responding',
  },

  banner: {
    title: 'Welcome to Varo chat',
    body: "Reminder, we'll never ask for your password or account information. Please don't include this information in a chat session.",
    buttonLabel: 'Start chat',
    bannerHi: 'Hi',
  },

  leaveChat: {
    buttonLabel: 'End chat',
    leaveChatConfirmation: {
      title: 'Are you sure you want to end the chat?',
      description: 'You’ll need to start a new session later.',
      buttons: {
        submit: 'Yes, end chat',
        cancel: 'Cancel',
      },
    },
    chatSurvey: {
      buttonTitle: 'Send feedback',
    },
  },

  chat: {
    callUsOptionsText: 'File a dispute or set up mobile wallet',
    cards: 'Cards',
    chatbotAbleToResolveIssue: 'Was our chatbot able to resolve your inquiry?',
    chatBtn: 'Chat with us',
    chatHoursInfo:
      'You can chat with us 24/7. Support is closed on federal holidays.',
    chatInputField: 'chat-input-field',
    chatWithUsSubText:
      'Get fast answers through chat any hour, any day. Talk to you soon!',
    chatWithUsText: 'Chat with us for almost everything',
    faqText: 'Understanding Varo Believe',
    hereInVaroAppText: 'here in your Varo app',
    marketingNotificationText: 'Marketing notifications',
    messageBubble: 'messageBubble',
    popularTopics: 'Popular topics',
    sendIcon: 'send-icon',
    starRatingQuestionText:
      "How satisfied were you with our chatbot's support?",
    starSurveyQuestionText:
      'How satisfied are you with the assistance you got through chat today?',
    taxes: 'Taxes',
    yourNotificationText: 'your notifications',
    copyText: 'Copy',
  },
};
export default chatStringsEN;
